import {getCookie} from "./CookieUtil"
export const XSRF_HEADER = "X-XSRF-TOKEN";
export const ERROR_CODE_BAD_INPUT = "Illegal.Input";
export const ERROR_CODE_SMS_RATE_LIMIT_REACHED = "SMS_RATE_LIMIT_REACHED";
export const ERROR_CODE_SMS_MAX_LIMIT_REACHED = "SMS_MAX_LIMIT_REACHED";
const XSRF_COOKIE = "XSRF-TOKEN";

export const getContentType = (response) => {
    const contentType = response.headers.get("content-type");
    return contentType;
};

export const getXsrfToken = () => getCookie(XSRF_COOKIE);

export const getXsrfHeader = () => {
    const result = {};
    result[XSRF_HEADER] = getXsrfToken();
    return result;
};

export const createFetchHeaders = (accept, contentType) => ({
   ...getXsrfHeader(),
   Accept: accept,
   "Content-Type": contentType
});

export const fetchExchange = ({path, body, method="GET", contentType="application/json", accept="application/json", addHeaders = true}) => {
    const options = {
        method,
        credentials: "same-origin",
        headers: addHeaders ? createFetchHeaders(accept, contentType) : {}
    };
    if (body && body.length > 0){
        options.body = body;
    }
    return fetch(path, options);
};

export const fetchGet = ({path, contentType="application/json", accept="application/json", addHeaders = true}) => fetchExchange({path, accept, contentType, addHeaders});
export const fetchPost = ({path, body, contentType="application/json", accept="application/json"}) => fetchExchange({
    path, body, method: "POST",  accept, contentType
});

export const isResponseJson = response => {
    const contentType = getContentType(response);
    return contentType && contentType.indexOf("application/json") !== -1;
};

export const throwIfError = obj => {
    if (obj && (obj.errorCode || (obj.errorMessage && obj.errorMessage.length > 0))){
        throw obj;
    }
};

export const fetchResponseHandler = (response) => {
    if (isResponseJson(response)){
        return response.json()
            .then(data => {
                throwIfError(data);
                return new Promise(resolve => {
                    resolve(data);
                });
            });
    }
    throw {
        errorCode: "INVALID_RESPONSE_TYPE",
        errorMessage: "Only JSON response is allowed. However received response content type is " + getContentType(response)
    }
};

export const fetchVoidResponseHandler = (response) => {
    if (response.ok){
        // Response is good, it's done, just return resolved promise.
        return Promise.resolve();
    } else {
        return fetchResponseHandler(response)
            // if the response is json, then throw the object returned since it must be error object
            .then(e => {throw e;});
    }
};

export const extractMessage = (e) => {
    console.log(e);
    let errorMessage;
    if (!e){
        errorMessage = null;
    } else if (typeof(e) === "string"){
        errorMessage = e;
    } else {
        errorMessage = e.errorMessage ? e.errorMessage :e.message;
    }
    return errorMessage;
};


